import { jsxs as j, Fragment as Y, jsx as a } from "react/jsx-runtime";
import { addCommas as O, sortAsc as B, getValidationMessage as G } from "@strata/helper-functions";
import * as N from "yup";
import { IconNames as V } from "@blueprintjs/icons";
import { Icon as D } from "@strata/react-status-icons";
import "./main.scss";
import { ProgressBar as K } from "@strata/react-progress-bar";
import { FileInput as W, Intent as Z, Classes as w } from "@blueprintjs/core";
import { FormFieldWrapper as H } from "@strata/react-form-field-wrapper";
import T from "classnames";
import { useMemo as J, useState as Q, useEffect as X } from "react";
import { Field as R } from "formik";
const q = 14, k = (t) => t == null ? "" : t > 1e9 ? `${O(t / 1e9)} gb` : t > 1e6 ? `${O(t / 1e6)} mb` : t > 10 ? `${O(t / 1e3)} kb` : `${O(t)} bytes`, A = ({
  filename: t,
  fileSize: i = void 0,
  readOnly: l = !1,
  onFileClick: o = void 0,
  onRemoveFileClick: r = void 0
}) => /* @__PURE__ */ j(Y, { children: [
  /* @__PURE__ */ j(
    "span",
    {
      className: "sds_file-list__filename",
      role: "button",
      tabIndex: 0,
      onClick: () => o == null ? void 0 : o(t),
      onKeyDown: (d) => {
        d.key === "Enter" && (o == null || o(t));
      },
      children: [
        /* @__PURE__ */ a(D, { icon: V.DOCUMENT, size: q, className: "margin__right--small" }),
        t,
        /* @__PURE__ */ a("span", { className: "sds_file-list__size", children: k(i) })
      ]
    }
  ),
  !l && /* @__PURE__ */ a(
    D,
    {
      icon: V.CROSS,
      size: q,
      intent: D.Intent.SECONDARY,
      onClick: () => r == null ? void 0 : r(t),
      title: "Remove",
      className: "padding__right--small"
    }
  )
] }), C = ({ filename: t }) => /* @__PURE__ */ j("div", { style: { width: "100%" }, children: [
  /* @__PURE__ */ a("div", { className: "margin__bottom--small", children: `Uploading ${t} ...` }),
  /* @__PURE__ */ a(K, { completed: 1, total: 1, animate: !0, stripes: !0 })
] }), tt = N.object({
  name: N.string().required(),
  size: N.number().required(),
  isUploading: N.bool()
}), et = ({
  files: t = [],
  readOnly: i = !1,
  onFileClick: l,
  onRemoveFileClick: o
}) => t.length > 0 ? /* @__PURE__ */ a("div", { className: "sds_file-list", children: /* @__PURE__ */ a("ul", { children: t.sort((r, d) => B(r.name, d.name)).map((r) => /* @__PURE__ */ a("li", { children: r.isUploading ? /* @__PURE__ */ a(C, { filename: r.name }) : /* @__PURE__ */ a(
  A,
  {
    filename: r.name,
    fileSize: r.size,
    readOnly: i,
    onFileClick: l,
    onRemoveFileClick: o
  }
) }, r.name)) }) }) : /* @__PURE__ */ a("div", { className: "sds_file-list__no-files", children: "No files have been uploaded." }), st = (t) => {
  const i = {};
  return t.forEach((l) => {
    i[l.name] = {
      name: l.name,
      size: l.size,
      isUploading: l.isUploading ?? !1
    };
  }), i;
}, M = ({
  id: t,
  disabled: i = !1,
  fill: l,
  helperText: o,
  label: r = "",
  required: d = !1,
  requiredValidationMessage: E,
  verticalSpacingSmall: x = !1,
  accept: L,
  initialFiles: I = void 0,
  maxAllowedFiles: u = void 0,
  onAddFiles: v = void 0,
  onRemoveFile: h = void 0,
  onFileClick: S,
  onBlur: b,
  onChange: c = void 0,
  autoFocus: $ = !1,
  tabIndex: z,
  inputRef: _ = void 0
}) => {
  const p = J(() => st(I ?? []), [I]), [g, f] = Q(p);
  X(() => {
    f(p);
  }, [p]);
  const F = async (e) => {
    let s = {};
    try {
      if (u != null) {
        const n = Math.max(0, u - Object.keys(g).length);
        e.splice(0 + n, e.length - n);
      }
      f((n) => {
        const m = {};
        return e.forEach((y) => {
          m[y.name] = {
            name: y.name,
            size: y.size,
            isUploading: !0
          };
        }), s = {
          ...n,
          ...m
        }, s;
      }), await (v == null ? void 0 : v(e)), f((n) => (s = { ...n }, e.forEach((m) => {
        s[m.name].isUploading = !1;
      }), s));
    } catch {
      f((n) => (s = { ...n }, e.forEach((m) => {
        const { [m.name]: y, ...U } = s;
        s = U;
      }), s));
    } finally {
      c == null || c(Object.values(s));
    }
  }, P = (e) => {
    (async () => {
      const s = { ...g[e] };
      let n = {};
      try {
        f((m) => {
          const { [e]: y, ...U } = m;
          return n = U, U;
        }), await (h == null ? void 0 : h(e));
      } catch {
        f((m) => (n = { ...m, [e]: s }, n));
      } finally {
        c == null || c(Object.values(n));
      }
    })();
  };
  return /* @__PURE__ */ j(
    "div",
    {
      className: T("sds_file-upload__container", {
        "margin__bottom--xx-large": !x
      }),
      children: [
        /* @__PURE__ */ a(
          H,
          {
            label: r,
            labelFor: t,
            disabled: i,
            helperText: o,
            inline: !1,
            fill: l,
            required: d,
            requiredValidationMessage: E,
            verticalSpacingSmall: !0,
            inputContent: /* @__PURE__ */ a("div", { className: "sds_file-upload", children: /* @__PURE__ */ a(
              W,
              {
                disabled: i || u != null && Object.keys(g).length >= u,
                text: "Choose file...",
                buttonText: "Browse",
                fill: !0,
                inputProps: {
                  multiple: !0,
                  id: t,
                  accept: L,
                  autoFocus: $,
                  tabIndex: z,
                  ref: _,
                  // Needed to show blue outline when focused
                  onFocus: (e) => {
                    var s;
                    return (s = e.target.nextElementSibling) == null ? void 0 : s.classList.add(w.ACTIVE);
                  },
                  onBlur: (e) => {
                    var s;
                    (s = e.target.nextElementSibling) == null || s.classList.remove(w.ACTIVE), b == null || b(e);
                  }
                },
                onInputChange: (e) => {
                  (async () => {
                    try {
                      await F([
                        ...e.target.files ?? []
                      ]);
                    } finally {
                      e.target.value = "";
                    }
                  })();
                },
                className: T("sds_file-upload__input", {
                  [`sds_file-upload__input--${Z.DANGER}`]: E
                })
              }
            ) })
          }
        ),
        /* @__PURE__ */ a(
          et,
          {
            files: Object.values(g),
            onFileClick: S,
            onRemoveFileClick: P,
            readOnly: i
          }
        )
      ]
    }
  );
};
M.validator = () => N.array(tt);
const at = ({
  id: t,
  disabled: i,
  fill: l,
  helperText: o,
  label: r,
  required: d,
  requiredValidationMessage: E,
  verticalSpacingSmall: x,
  accept: L,
  maxAllowedFiles: I,
  onAddFiles: u,
  onRemoveFile: v,
  onFileClick: h,
  onBlur: S,
  onChange: b,
  autoFocus: c,
  tabIndex: $,
  inputRef: z
}) => /* @__PURE__ */ a(R, { name: t, children: ({ field: _, form: p }) => /* @__PURE__ */ a(
  M,
  {
    id: _.name,
    label: r,
    required: d,
    requiredValidationMessage: E ?? G(_.name, p),
    onChange: b ?? ((g) => p.setFieldValue(_.name, g)),
    onBlur: S ?? p.handleBlur,
    disabled: i,
    fill: l,
    helperText: o,
    verticalSpacingSmall: x,
    accept: L,
    autoFocus: c,
    tabIndex: $,
    inputRef: z,
    initialFiles: _.value,
    maxAllowedFiles: I,
    onAddFiles: u,
    onRemoveFile: v,
    onFileClick: h
  }
) });
at.validator = M.validator;
export {
  et as FileList,
  M as FileUpload,
  at as FileUploadFormik
};
//# sourceMappingURL=index.js.map
